var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 .5)",
    stroke: "#00458A",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32 8.5h11.348c.036 0 .069 0 .104.005a.862.862 0 0 1 .492.205c.121.105.21.233.27.39a.99.99 0 0 1 .075.432c-.015.173-.05.345-.144.489l-.038.055-.023.028-.025.038L16 15.5l.044 4.422a1.105 1.105 0 0 1-.414.864l-.061.043-.325.208-.653.408-1.475.93a.702.702 0 0 1-.689.061c-.29-.136-.46-.43-.47-.776.037-3.254.037-5.062 0-5.423-.036-.361-.188-.774-.457-1.237l-3.637-4.518c-.081-.112-.162-.224-.241-.337a1.247 1.247 0 0 1-.185-.35.854.854 0 0 1-.044-.366c.018-.172.05-.339.144-.483.089-.136.19-.26.33-.333a.972.972 0 0 1 .359-.108L8.32 8.5Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ef04b45926a8562740e8fa2fc12b5e71.svg";
export { ForwardRef as ReactComponent };